import React from "react";
import { MdClose, MdEdit } from "react-icons/md";

export default function ViewFunctionality({ funcData, onClose, onEdit }) {
  if (!funcData) return null;

  return (
    <div className="uf-card d-flex flex-column h-100">
      {/* ✅ Header */}
      <div className="uf-header">
        <h5>Functionality Details</h5>
        <button onClick={onClose}>
          <MdClose />
        </button>
      </div>

      {/* ✅ Body */}
      <div className="uf-body">
        <div className="uf-grid">
          <div>
            <label className="form-label fw-bold">Functionality Name</label>
            <input
              type="text"
              className="form-control"
              value={funcData.name || ""}
              readOnly
            />
          </div>

          <div>
            <label className="form-label fw-bold">Code</label>
            <input
              type="text"
              className="form-control"
              value={funcData.code || ""}
              readOnly
            />
          </div>

          <div>
            <label className="form-label fw-bold">Module</label>
            <input
              type="text"
              className="form-control"
              value={funcData.module || ""}
              readOnly
            />
          </div>

          <div>
            <label className="form-label fw-bold">Type</label>
            <input
              type="text"
              className="form-control"
              value={funcData.type || ""}
              readOnly
            />
          </div>

          <div className="col-span-2">
            <label className="form-label fw-bold">Description</label>
            <textarea
              className="form-control"
              rows={3}
              value={funcData.description || ""}
              readOnly
            />
          </div>

          <div>
            <label className="form-label fw-bold">Status</label>
            <div>
              <span
                className={`badge ${
                  funcData.is_active ? "bg-success" : "bg-secondary"
                }`}
              >
                {funcData.is_active ? "Active" : "Inactive"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Footer */}
      <div className="uf-actions">
        <button className="btn btn-cancel" onClick={onClose}>
          Close
        </button>
        <button
          className="btn btn-primary"
          onClick={() => onEdit && onEdit(funcData)}
        >
          <MdEdit size={16} className="me-1" />
          Edit Functionality
        </button>
      </div>
    </div>
  );
}
